import React from 'react';
import { observer } from 'mobx-react';
import { PumpLandingTemplate } from 'themes/application/pumps/pages';
import { setCurrentView } from 'core/utils';
import { PumpViewStore } from 'application/pumps/stores';

@setCurrentView((rootStore) => new PumpViewStore(rootStore), 'pumpView')
@observer
class PumpLanding extends React.Component {
    render() {
        return <PumpLandingTemplate {...this.props} />
    }
}

export default PumpLanding;